import React, { useEffect, useState } from 'react';
import {APP_DOMAIN } from '../../../constants/constants';
import { useCoverLetter } from '../../../context/CoverLetterContext';

const WorkStyleForm = ({ data, save }) => {

  const workStyleList = [
    {
      title: "Pioneering",
      excerpt: "You're energized by creative and innovative work environments."
    },
    {
      title: "Empowering",
      excerpt: "You're adept at guiding teams through empowering and decisive task allocation."
    },
    {
      title: "Inquisitive",
      excerpt: "You have a talent for problem solving and versatility."
    },
    {
      title: "Systematic",
      excerpt: "You introduce organization and concentration to optimize tasks."
    },
    {
      title: "Enterprising",
      excerpt: "You consistently exceed expectations in achieving goals and ensuring prompt task completion."
    },
    {
      title: "Collaborative",
      excerpt: "You thrive in cooperative environments and derive satisfaction from assisting others."
    }
  ]

  const WorkStyleFigure = (i) => {
    let f;
    switch (String(i + 1)) {
      case '1':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s1.svg`} alt="Artistic icon"/></figure>
        break;
      case '2':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s2.svg`} alt="Enterprising icon"/></figure>
        break;
      case '3':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s3.svg`} alt="Investigative icon"/></figure>
        break;
      case '4':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s4.svg`} alt="Organized icon"/></figure>
        break;
      case '5':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s5.svg`} alt="Practical icon"/></figure>
        break;
      case '6':
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s6.svg`} alt="Service-oriented icon"/></figure>
        break;
      default:
        f = <figure><img src={`${APP_DOMAIN}/assets/images/work-s6.svg`} alt="Service-oriented icon"/></figure>
        break;
    }
    return f
  }
  return (<div className="screen-block">
    {/* //Duplicate screen start  */}
    <div className="work-style-row">
      {
        workStyleList.map((workStyle, i) => {
          return (
            <div
              key={`workstyle-${workStyle.title}`}
              className={`work-col${workStyle.title == data.work_style ? " selected" : ''}`}
              data-option={workStyle.title}
              onClick={() => {
                save(
                  (workStyle.title == data?.work_style) ?
                    { work_style: '' } :
                    { work_style: workStyle.title }
                )
              }}
            >
              <div className="img-title">{WorkStyleFigure(i)}
              <span>{workStyle.title}</span></div>
              <p>{workStyle.excerpt}</p>
            </div>
          )
        })
      }
    </div>
    {/* //Duplicate screen end  */}
  </div>)
}

export default WorkStyleForm;